module.exports = __webpack_public_path__ + "img/highSpeedRail-4.cf4c6a95.jpg";